import { createSlice } from '@reduxjs/toolkit';
import { mealTypeEnum } from '../utils/constants';
import { mealMatchesSearch } from '../utils/mealSearch';
const initialState = {
  mealList: [],
  filteredList: [],
  allergiesList: [],
  filteredAllergiesList: [],
  showOnly: [],
  searchValue: '',
  mealType: 'all',
};

const mealSlice = createSlice({
  name: 'meal',
  initialState,
  reducers: {
    addAllMeals: (state, action) => {
      state.mealList = action.payload;
      state.filteredList = action.payload;
    },
    searchMealList: (state, action) => {
      const { searchName } = action.payload;
      state.searchValue = searchName;
      state.filteredList = filterMeals(state);
    },
    addAllAllergies: (state, action) => {
      state.allergiesList = action.payload;
      state.filteredAllergiesList = action.payload;
    },
    searchAllergiesList: (state, action) => {
      const { searchName, language } = action.payload;
      if (searchName === '') {
        state.filteredAllergiesList = [...state.allergiesList];
        return;
      }

      const filteredList = state.allergiesList?.filter((allergy) => {
        return language === 'English'
          ? allergy.nameEn?.toLowerCase().includes(searchName?.toLowerCase())
          : allergy.nameNo?.toLowerCase().includes(searchName?.toLowerCase());
      });

      console.log('filter', searchName);
      console.dir(filteredList);

      state.filteredAllergiesList = filteredList;
    },
    updateShowOnlyFilter: (state, action) => {
      const { filterType } = action.payload;
      console.log('updateShowOnlyFilter', filterType);
      if (state.showOnly.includes(filterType)) {
        state.showOnly = state.showOnly.filter((item) => item !== filterType);
      } else {
        state.showOnly = [...state.showOnly, filterType];
      }
      console.log('updateShowOnlyFilter', 'after push');
      console.dir(state.showOnly);
      state.filteredList = filterMeals(state);
    },
    reset: () => {
      return initialState;
    },
    updateMealType: (state, action) => {
      const { mealType } = action.payload;
      state.mealType = mealType;
      state.filteredList = filterMeals(state);
    },
  },
});

const filterMeals = (state) => {
  return state.mealList?.filter((meal) => {
    var mealType = meal.isCateringFood
      ? mealTypeEnum.catering
      : meal.isAddOnItem ?? false // if isAddOnItem is undefined then return false
      ? mealTypeEnum.add_ons
      : mealTypeEnum.meal;
    // console.log(`mealType = ${mealType}`);
    return (
      (state.showOnly.includes('Halal') ? meal.isHalal : true) &&
      (state.showOnly.includes('Vegetarian') ? meal.isVeg : true) &&
      (state.mealType === mealTypeEnum.all
        ? true
        : mealType === state.mealType) &&
      (state.searchValue.length > 0
        ? mealMatchesSearch(meal, state.searchValue)
        : true)
    );
  });
};

export const MealAction = mealSlice.actions;
export default mealSlice;
